import { c as _c } from "react/compiler-runtime";
import { CancelCircleIcon, CheckmarkCircle02Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { cn } from "@/lib/utils";
import { Service } from "@/lib/types/service";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
interface ServiceCardProps {
  service: Service;
}
function ServiceCard(t0) {
  const $ = _c(25);
  const {
    service
  } = t0;
  let t1;
  if ($[0] !== service.name) {
    t1 = cn("flex flex-col gap-3 w-85 md:max-w-120", service.name.includes("Launch") && "border border-primary shadow-lg shadow-primary/50");
    $[0] = service.name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== service.name) {
    t2 = <CardTitle className="text-xl">{service.name}</CardTitle>;
    $[2] = service.name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== service.description) {
    t3 = <CardDescription>{service.description}</CardDescription>;
    $[4] = service.description;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <CardHeader className="pb-0">{t2}{t3}</CardHeader>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== service.features) {
    t5 = service.features.map(_temp);
    $[9] = service.features;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== service.notIncluded) {
    t6 = service.notIncluded.map(_temp2);
    $[11] = service.notIncluded;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <CardContent className="flex-1 flex flex-col"><ul className="space-y-2 flex-1 h-full">{t5}{t6}</ul></CardContent>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== service.price) {
    t8 = new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
      maximumFractionDigits: 0
    }).format(service.price);
    $[16] = service.price;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = <CardFooter className="flex flex-col items-start justify-center gap-2"><span className="text-4xl font-bold">{t8}</span></CardFooter>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t1 || $[21] !== t4 || $[22] !== t7 || $[23] !== t9) {
    t10 = <Card className={t1}>{t4}{t7}{t9}</Card>;
    $[20] = t1;
    $[21] = t4;
    $[22] = t7;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}
function _temp2(item) {
  return <li key={item} className="flex items-center gap-2 text-sm md:text-base text-muted-foreground"><HugeiconsIcon icon={CancelCircleIcon} className="text-red-700 w-5 h-5 shrink-0" />{item}</li>;
}
function _temp(feature) {
  return <li key={feature} className="flex items-center gap-2 text-base md:text-lg"><HugeiconsIcon icon={CheckmarkCircle02Icon} className="text-green-700 w-5 h-5 shrink-0" />{feature}</li>;
}
export { ServiceCard };